
    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
	import Partner from '../../components/partner.vue'
	import Outbound from '../../components/outbound.vue'
	const packageslist = namespace('packageslist')
	const inbound = namespace('inbound')
    @Component({
        components: {
			Partner,
			Outbound
        }
    })
    export default class Home extends Vue{
        type:number = 0 //出库类型
		code:string = "" //出库的取件码
		partner:string = '' //选择的快递员
		phone = '' //已派件登记的手机号
		notlist:any = [] //未出库列表
		outboundStatus:boolean = false
		@packageslist.Action('outbound') outbound:any
		@packageslist.Action('register') register:any
		@inbound.Action('getPhoneTips') getPhoneTips:any
		@inbound.Action('getCodeInfo') getCodeInfo
		// 快递员改变
        partnerChange(e:string){
            this.partner = e
        }
		async outboundFun(){ // 出库
			if(this.code === '') return this.$message.error('单号不能为空');
			if(this.type === '1'){
				this.registerAction();
			}else{
				const res = await this.outbound({id:this.code, data:{problem:this.type == 2}})
				if(res){
					if(typeof res != 'string'){
						this.notlist = res
						if(res.length > 0){
							this.outboundStatus = true
						}
					}
					this.$message({ message: '出库成功', type: 'success' });
					this.playChukuSuccess()
					this.code = ''
				}else{
					this.playChukuFail()
				}
			}
		}
		async registerAction(){
			const codeInfo = await this.getCodeInfo({
                code: this.code
            })
			if(codeInfo){
				if(codeInfo.partner.lenght === 0) return this.$message.error('请选择快递员');
				if(this.partner) codeInfo.partner.map( item => {
					if(item._id != this.partner){
						return this.$message.error('你选择的快递员可能不对,请重新选择');
					}
				})
				this.partner = this.partner ? this.partner : codeInfo.partner[0]._id;
				this.phone = codeInfo.phonetips[0] ? codeInfo.phonetips[0].phone : codeInfo.phonestr;
			}
			const res = await this.register({
				code: this.code,
				partner: this.partner,
				phone: this.phone
			})
			if(res){
				this.playChukuSuccess()
				this.$message({ message: '登记成功', type: 'success' });
				this.code = ''
				this.phone = ''
				this.partner = ''
				this.$refs.code.focus();
			}else{
				this.playChukuFail()
			}
		}
		hideDiadlong(e:any){
			this.outboundStatus = false
		}
		playChukuSuccess(){
			const audio = new Audio(require('../../assets/chuku-success.mp3'));
			audio.play();
		}
		playChukuFail(){
			const audio = new Audio(require('../../assets/chuku-fail.mp3'));
			audio.play();
		}
		// 搜索电话号码
        async searchPhoneAsync(queryString:any, cb:any) {
            if(!queryString){
                cb([])
            }
            if(this.phone.length > 3 && this.phone.length !== 11){
                const res = await this.getPhoneTips({
                    phone: this.phone
                })
                cb(res)
	            }else{
		            cb([])
	        }
		}
		// 选择搜索出来的电话号码
        phoneSelect(e:any){
            this.phone = e.phone
        }
    }
